<template>
  <div class="">
    <!-- {{report}} -->
    <table>
      <thead>
        <tr class="header-of-page">
          <div class="d-flex p-3">
            <div class="center" style="width: 50%">
              <img :src="img" class="logo" alt="" />
            </div>
            <div class="content">
              <div class="row pb-1">
                <div class="col-10 title name">
                  تقرير الارباح
                  <span class="mr-2">
                    <span class="mr-2"> من تاريخ {{ dateRange[0] }}</span>
                    <span class="mr-2">الي تاريخ {{ dateRange[1] }}</span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </tr>
      </thead>

      <tbody class="bg-w" v-if="report != null">
        <tr>
          <table class="table" v-if="report != null">
            <colgroup>
              <col name="el-table_3_column_11" width="5%" />
              <col name="el-table_3_column_12" width="20%" />
              <col name="el-table_3_column_13" width="10%" />
              <col name="el-table_3_column_14" width="10%" />
              <col name="el-table_3_column_15" width="10%" />
              <col name="el-table_3_column_16" width="10%" />
              <col name="el-table_3_column_17" width="10%" />
              <col name="el-table_3_column_18" width="10%" />
            </colgroup>
            <thead>
              <tr>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_11 is-leaf"
                >
                  <div class="text-center">#</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_12 is-leaf"
                >
                  <div class="pr-1" v-if="title">اليوم</div>
                  <div class="pr-1" v-else>شهر</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_13 is-leaf"
                >
                  <div class="pr-1">مبيعات</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_14 is-leaf"
                >
                  <div class="text-center">خصومات</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_15 is-leaf"
                >
                  <div class="text-center">التكلفة</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_16 is-leaf"
                >
                  <div class="text-center">الربح</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_17 is-leaf"
                >
                  <div class="text-center">المشتريات</div>
                </th>
                <th
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_18 is-leaf"
                >
                  <div class="text-center">مصروفات</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="" v-for="(item, index) in report" :key="index">
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_11 is-leaf"
                >
                  <div class="bg-Lightgray align-center">
                    {{ index + 1 }}
                  </div>
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_12 is-leaf"
                >
                  <div class="align-center" v-if="title">
                    {{ item.date | moment("dddd | Do / MM / YYYY") }}
                  </div>
                  <div class="align-center" v-else>
                    {{ item.date | moment("MMMM") }}
                  </div>
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_13 is-leaf"
                >
                  <div class="align-center">
                    {{ item.totalSales }}
                  </div>
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_14 is-leaf text-center"
                >
                  <div class="bg-Lightgray align-center">
                    {{ item.totalSalesDiscount }}
                  </div>
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_15 is-leaf text-center"
                  style="text-align: center"
                >
                  {{ item.total_buy }}
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_16 is-leaf text-center"
                  style="text-align: center"
                >
                  {{ item.profit }}
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_17 is-leaf text-center"
                  style="text-align: center"
                >
                  {{ item.totalPurchases }}
                </td>
                <td
                  colspan="1"
                  rowspan="1"
                  class="el-table_3_column_18 is-leaf text-center"
                  style="text-align: center"
                >
                  {{ item.shopExpenses }}
                </td>
              </tr>
            </tbody>
          </table>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import { ipcRenderer } from "electron";
// window.ipcRenderer = ipcRenderer;
export default {
  props: ["report", "dateRange", "title", "img"],

  data() {
    return {
      currentdate: new Date(),
    };
  },
  methods: {
    numberToFixed(number) {
      let num = Number(number);
      return Math.floor(num * 100) / 100;
    },
  },

  mounted() {
    // this.invoiceDetails = JSON.parse(localStorage.getItem("sale_invoice"));
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/_color.scss";
@import url("https://fonts.googleapis.com/css2?family=Cairo:wght@300;400;600;700&family=Open+Sans:wght@400;600;700&display=swap");
body {
  font-family: cairo !important;
}
.bg-w {
  margin: 0;

  padding: 0;
}
.header-of-page {
  background-color: #f7f8fa;

  .p-3 {
    padding: 22px 18px !important;
  }
  .logo {
    width: 18%;
    .img-fluid {
      width: 56px;
      height: 56px;
    }
  }
  .center {
    .logo {
      height: 47px;
      width: 75px;
    }
  }
  .content {
    width: 50%;
    .title {
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: bold;
      letter-spacing: 0;
    }
  }
  .border {
    width: 100%;
    padding: 13px 8px;
    border-top: 2px solid #fff;
    .first,
    .second {
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: 600;
      display: flex;
      align-items: center;

      margin-left: 22px;
      .icon {
        font-size: 7px;
        color: #d8d8d8;
      }
      P {
        text-align: center !important;
        width: 96%;
      }
    }
    .first {
      width: 45%;
    }
    .second {
      width: 35%;
    }
    .third {
      width: 25%;
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: 600;
      display: flex;
      align-items: center;

      .icon {
        font-size: 4px;
        color: #d8d8d8;
      }
    }
  }
}
.bg-whi {
  width: 100%;
  height: 21vh;
  display: flex;
  align-items: center;
  justify-content: center;
  .firstDiv {
    background-color: #f7f8fa;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    width: 95%;
    height: 19vh;

    .thead {
      background-color: #f2f3f5;
      height: 8vh;
      width: 100%;
      color: #000000;
      font-family: Cairo;
      font-size: 10px;
      font-weight: bold;
    }
    .tbody {
      background-color: $subColor;
      height: 8vh;
      width: 100%;
      color: #000000;
      font-family: Cairo;
      font-size: 12px;
      font-weight: bold;
    }
    .cell {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
.footer-of-page {
  text-align: center;
  width: 100%;
  position: fixed;
  bottom: 0;
  height: 28px;

  background: #f7f8fa;
  p {
    font-family: Cairo;
    font-size: 8px;
  }
}
table {
  width: 100%;
  border: none;
  caption-side: bottom;
  thead tr {
    border: none !important;
  }
  tr {
    border: none !important;
  }
}
.table {
  margin: 1rem auto;
  width: 95%;
  border: none;
  border-collapse: collapse;
  border-bottom: none !important;
  font-size: 13px !important;
  thead {
    padding: 10px;

    border: none;
    tr {
      th {
        padding: 7px;
        border: 1px solid #000;
        .cell {
          font-weight: normal !important;
          color: #000000;
          font-family: Cairo;
          font-size: 12px !important;
          font-weight: 600;
          display: flex;
        }
      }
    }
  }
  tbody {
    border: none;
    tr {
      td {
        text-align: right;
        padding: 3px;
        margin-bottom: 0.5rem;
        border: 1px solid #000;
        .cell {
          font-weight: normal !important;
          height: 70px;
          color: #000000;
          font-family: Cairo;
          font-size: 10px;
          font-weight: 600;
          display: flex !important;

          &.bg-gray {
            background-color: #e5e5e5;
          }
          &.bg-Lightgray {
            background-color: #f7f8fa;
            border: 1px solid #fff;
          }
        }
      }
    }
  }
  tfoot {
    td {
      border: 1px solid #000 !important;
    }
  }

  tr,
  td {
    border: none;
    line-height: 1.7;
    text-align: right;
  }
  tfoot {
    border: none;
    tr {
      height: 30px;
      border: none;
    }
  }
}
.pb-2 {
  padding-bottom: 1rem;
}
.text-center {
  text-align: center;
}
.align-center {
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Open Sans" !important;
}
.d-none {
  display: none;
}
.mt {
  margin-top: 182px;
}
.onlyAlign {
  display: flex;
  align-items: center;
  padding-right: 0.5rem;
}
.pb-1 {
  margin-bottom: 0.5rem;
}
.mr-auto {
  margin-right: auto;
}
.pr-1 {
  padding-right: 0.5rem;
}
.d-flex {
  display: flex !important;
}
.paymentDitals {
  border-collapse: collapse;
  background-color: white;

  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.total-qty {
  border-collapse: collapse;
  background-color: white;
  margin-right: auto;

  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.result {
  width: 95%;
  margin: 20px auto;
  border-collapse: collapse;
  background-color: white;
  td {
    border: 1px solid;
    text-align: center;
    &:first-of-type {
      background-color: #e0e0e0;
    }
  }
}
.full-width {
  width: 100% !important;
  margin-left: 0;
  margin-right: 0;
  padding: 0 15px;
  font-size: 14px;
}
</style>
